import React from "react";
import { Parallax } from "react-scroll-parallax";
import Casana_home from "../../resources/mockups/Casana_home.png";
import Casana_stay from "../../resources/mockups/Casana_stay.png";

export const Casana = () => {
  return (
    <div className="h-screen grid grid-cols-2 items-center md:-mt-40 -mt-64">
      <div className="flex flex-col">
        <div className="ml-5 md:ml-20">
          <a href="https://casana.app/" target="_blank" rel="noreferrer">
            <h1 className="text-4xl md:text-8xl mb-12 font-mono transition-transform hover:translate-x-2">
              Casana
            </h1>
          </a>
          <div className="flex mb-6"></div>
          <p className="md:text-4xl">
            Casana ist eine von mir end-to-end entwickelte Mobile App zur privaten Koordination geteilter Räume für Familie und Freunde. Aktuell in der Launch-Vorbereitung.          </p>
        </div>
      </div>
      <div className="flex justify-center">
        <Parallax speed={60} className="">
          <img src={Casana_home} alt="Mockup" className="w-80" />
        </Parallax>
        <Parallax speed={80} className="pt-20">
          <img
            src={Casana_stay}
            alt="Mockup"
            className="w-80 hidden md:block"
          />
        </Parallax>
      </div>
    </div>
  );
};
